/* eslint-disable import/no-extraneous-dependencies */
// import sum from 'lodash/sum';
// import uniq from 'lodash/uniq';
// import uniqBy from 'lodash/uniqBy';
import { createSlice } from '@reduxjs/toolkit';
// utils
import { axiosInstance } from "../../utils/axiosInstance"
// ----------------------------------------------------------------------

const url = process.env.BACKEND_URL;

const initialState = {
  isLoading: false,
  error: null,
  saveHotels: [],
  hotelCityList: [],
  hotelList: undefined,
  hotelListDummy: undefined,
  hotelDetail: [],
  hotelsDetail: [],
  roomDetail: [],
  roomDetailNew: undefined,
  hotelBookingResponse: [],
  hotelPreBookingRes: undefined,
  cityListRes: [],
  getHotelName: []
};

const slice = createSlice({
  name: 'hotel',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    //GET SAVEHOTELS
    getSaveHotelSuccess(state, action) {
      state.isLoading = false;
      state.saveBookingHotels = action.payload;
    },
    //GET getHotelCityList
    getHotelCityListSuccess(state, action) {
      state.isLoading = false;
      state.hotelCityList = action.payload;
    },
    //GET getHotelList
    getHotelListSuccess(state, action) {
      state.isLoading = false;
      state.hotelList = action.payload;
    },
    //GET getHotelListDummy
    getHotelListDummySuccess(state, action) {
      state.isLoading = false;
      state.hotelListDummy = action.payload;
    },
    //GET HotelDetail
    getHotelDetailSuccess(state, action) {
      state.isLoading = false;
      state.hotelDetail = action.payload;
    },
    getHotelDetailsSuccess(state, action) {
      state.isLoading = false;
      state.hotelsDetail = action.payload;
    },
    getRoomDetailsSuccess(state, action) {
      state.isLoading = false;
      state.roomDetail = action.payload;
    },
    getRoomDetailsNewSuccess(state, action) {
      state.isLoading = false;
      state.roomDetailNew = action.payload;
    },
    //Book Hotel
    getHotelBookingSuccess(state, action) {
      state.isLoading = false;
      state.hotelBookingResponse = action.payload;
    },
    getHotelSaveBookingSuccess(state, action) {
      state.isLoading = false;
      state.hotelSaveBookingRes = action.payload;
    },
    getHotelPreBookingSuccess(state, action) {
      state.isLoading = false;
      state.hotelPreBookingRes = action.payload;
    },
    getSearchActivityFilterSuccess(state, action) {
      state.isLoading = false;
      state.searchActivityFilterRes = action.payload;
    },
    getSearchActivityListSuccess(state, action) {
      state.isLoading = false;
      state.searchActivityListRes = action.payload;
    },
    getSearchActivitySuccess(state, action) {
      state.isLoading = false;
      state.searchActivityRes = action.payload;
    },
    getCityListSuccess(state, action) {
      state.isLoading = false;
      state.cityListRes = action.payload;
    },
    getFilterListSuccess(state, action) {
      state.isLoading = false;
      state.filterListRes = action.payload;
    },
    getSearchHotelSuccess(state, action) {
      state.isLoading = false;
      state.getHotelName = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getCart,
  addToCart,
  resetCart,
  gotoStep,
  backStep,
  nextStep,
  deleteCart,
  createBilling,
  applyShipping,
  applyDiscount,
  increaseQuantity,
  decreaseQuantity,
} = slice.actions;

// ----------------------------------------------------------------------

//SAVEHOTELSBOOKINGS

export function getHotelCityList(saveBookingHotels) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        'http://api.tbotechnology.in/TBOHolidays_HotelAPI/CityList',
        {
          CountryCode: 'IN',
        },
        {
          auth: {
            username: 'RSLTOURTEST',
            password: 'Roy@29903427',
          },
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      dispatch(slice.actions.getHotelCityListSuccess(response));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getHotelList(listFilter) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/hotel/listHotel`,
        listFilter,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      dispatch(slice.actions.getHotelListSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.getHotelListSuccess(error));
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getHotelListDummy(listFilter) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/hotel/listHotelsByCity`,
        listFilter,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      dispatch(slice.actions.getHotelListDummySuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.getHotelListDummySuccess(error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getHotelListDummyReset() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    dispatch(slice.actions.getHotelListDummySuccess(undefined));

  };
}



export function getHotelDetail(hotelId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/hotel/hotelDetails`,
        hotelId,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      dispatch(slice.actions.getHotelDetailSuccess(response.data.responseData));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getHotelDetails(hotelId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/hotel/hotelDetail`,
        hotelId,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      dispatch(slice.actions.getHotelDetailsSuccess(response.data.hotelDetails));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getRoomDetails(hotelId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/hotel/roomDetails`,
        hotelId,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      dispatch(slice.actions.getRoomDetailsSuccess(response.data.roomDetails));
      dispatch(slice.actions.getRoomDetailsNewSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function postHotelBooking(hotelBooking) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/booking/hotel`,
        hotelId,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      dispatch(
        slice.actions.getHotelBookingSuccess(response.data.hotelDetails)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function hotelPreBooking(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/booking/preBook`,
        obj,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );


      dispatch(slice.actions.getHotelPreBookingSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function hotelSaveBooking(hotelBooking) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/booking/hotel`,
        hotelBooking,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      dispatch(slice.actions.getHotelSaveBookingSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function searchActivity(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/hotel/searchCity`, obj);
      dispatch(slice.actions.getSearchActivitySuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function searchActivityList(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/hotel/searchList`, obj);
      dispatch(
        slice.actions.getSearchActivityListSuccess(response.data.responseData)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function searchActivityFilter() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${url}/activity/filterLists`);
      dispatch(
        slice.actions.getSearchActivityFilterSuccess(response.data.responseData)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCityList(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/hotel/searchCity`, obj);
      dispatch(slice.actions.getCityListSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getFilterList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${url}/hotel/filterList`);
      dispatch(slice.actions.getFilterListSuccess(response.data.responseData));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function searchHotelName(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/hotel/searchHotelNames`, obj);
      dispatch(slice.actions.getSearchHotelSuccess(response.data.responseData));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}